<div mat-dialog-title>
    <span>{{'action.configuration' | translate}}</span>
    <button [mat-dialog-close]="data">
        <i class="fa fa-times"></i>
    </button>
</div>

<mat-dialog-content>
    <!-- PART 2 -->
    <div class="">
        <h3>{{'badges.modal.configuration.import_export' | translate}}</h3>
        
        <div class="wrap-file-actions">
            <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadEvent($event)" [backendResponse]="backendResponseDownloadedFile"></app-file-download>
            <app-file-upload appReadWrite (userWantsUploadEvent)="onUserWantsUploadEvent($event)" [backendResponse]="backendResponseUploadedFile"></app-file-upload>
        </div>
    </div>
</mat-dialog-content>

